export const SecurityQuestion = [
  'Mothers_maiden_name',
  'What_was_your_first_car',
  'Your_pets_name',
  'City_of_origin'
];
